// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1D_QM","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__Qvbzf"};